import React from 'react'
import PatchLink from 'lib/components/patch-link'
import Icon from 'lib/components/icon'
import SidebarStats from './sidebar-stats'

class SidebarDetail extends React.PureComponent {
  static defaultProps = {
    aggregate: {},
    description: '',
    getLabel: n => n,
    sidebarGroups: [],
    tooltips: {}
  }

  render() {
    const {
      aggregate,
      description,
      tooltips,
      getLabel,
      sidebarGroups
    } = this.props

    let clearSelection = { category: undefined, selected: undefined }

    return (
      <aside className="sidebar -detail">
        <div className="sidebar__main">
          <h2 className="type-subtitle -pad-inner">Details</h2>

          <div className="sidebar-detail__header">
            <h3 className="type-headline -pad-inner">{aggregate.Label}</h3>

            <hr style={{ backgroundColor: aggregate.Color }} />

            <PatchLink query={clearSelection} className="sidebar-detail__close">
              <Icon type="close" height="20px" width="20px" />
              <span className="screenreader-only">Clear Filter</span>
            </PatchLink>
          </div>

          <div
            className="sidebar-detail__desc -pad-inner"
            dangerouslySetInnerHTML={{ __html: `<p>${description || ''}</p>` }}
          />

          <SidebarStats
            aggregate={aggregate}
            getLabel={getLabel}
            tooltips={tooltips}
            sidebarGroups={sidebarGroups}
          />
        </div>
      </aside>
    )
  }
}

export default SidebarDetail



// WEBPACK FOOTER //
// ./src/components/sidebar-detail.js